import { combineReducers } from '@reduxjs/toolkit'

import conditions from './conditions'

const reducer = combineReducers({
  conditions,
})


export default reducer